import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import * as Sentry from '@sentry/angular-ivy';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import '@angular/common/locales/global/pt';
Sentry.init({
  dsn: 'https://bea5c6057ce14512b111b6c64e1f2c5a@o4505075781074944.ingest.sentry.io/4505075803881472',
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
    new Sentry.Replay(),
  ],
  tracesSampleRate: 0.5,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
